import { DateTime } from 'luxon'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/pro-light-svg-icons'

import { FormField, SectionDivider, Text } from '@domain-group/suit-theme'

import usePublicationEdition from '@hooks/usePublicationEdition'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'

interface PublicationDetailsProps {
  orderItemPayload: UseOrderItemPayload,
}

const PublicationDetails = (props: PublicationDetailsProps) => {
  const {
    orderItemPayload: {
      publication,
      publicationEdition,
    },
  } = props

  const publicationEditionPayload = usePublicationEdition(publicationEdition)
  const {
    deadlineStatuses: {
      artwork: { beforeDeadline: beforeArtworkDeadline },
      booking: { beforeDeadline: beforeBookingDeadline },
      editorial: { beforeDeadline: beforeEditorialDeadline },
      ofi: { beforeDeadline: beforeOfiDeadline },
    },
    deadlines: {
      artwork: artworkDeadline,
      booking: bookingDeadline,
      editorial: editorialDeadline,
      ofi: ofiDeadline,
    },
    hasArtworkDeadline,
    hasBookingDeadline,
    hasEditorialDeadline,
    hasOfiDeadline,
    publicationEdition: {
      publication_date,
    },
  } = publicationEditionPayload

  return (
    <>
      <SectionDivider boxProps={{ marginTop: 'large' }}>
        Publication
      </SectionDivider>

      {/*
       // @ts-expect-error TS2339 */}
      {publication.title && (
        <FormField
          direction="column"
          label="Publication"
          marginTop="large"
        >
          <Text fontSize="small">
            {/*
             // @ts-expect-error TS2339 */}
            {publication.title}
          </Text>
        </FormField>
      )}

      {!!publication_date && (
        <FormField direction="column" label="Edition" marginTop="large">
          <Text fontSize="small">
            {DateTime.fromFormat(publication_date, 'dd/MM/yyyy').toFormat('ccc d MMM')}
          </Text>
        </FormField>
      )}

      {hasBookingDeadline && (
        <FormField direction="column" label="Booking Deadline" marginTop="large">
          <Text color={beforeBookingDeadline ? 'green' : 'red'} fontSize="small">
            {!beforeBookingDeadline && <><FontAwesomeIcon icon={faClock} />{' '}</>}

            {DateTime.fromFormat(bookingDeadline, 'dd/MM/yyyy HH:mm').toFormat("ccc d MMM 'at' h:mma")}
          </Text>
        </FormField>
      )}

      {hasArtworkDeadline && (
        <FormField direction="column" label="Artwork Deadline" marginTop="large">
          <Text color={beforeArtworkDeadline ? 'green' : 'red'} fontSize="small">
            {!beforeArtworkDeadline && <><FontAwesomeIcon icon={faClock} />{' '}</>}

            {DateTime.fromFormat(artworkDeadline, 'dd/MM/yyyy HH:mm').toFormat("ccc d MMM 'at' h:mma")}
          </Text>
        </FormField>
      )}

      {hasEditorialDeadline && (
        <FormField direction="column" label="Editorial Deadline" marginTop="large">
          <Text color={beforeEditorialDeadline ? 'green' : 'red'} fontSize="small">
            {!beforeEditorialDeadline && <><FontAwesomeIcon icon={faClock} />{' '}</>}

            {DateTime.fromFormat(editorialDeadline, 'dd/MM/yyyy HH:mm').toFormat("ccc d MMM 'at' h:mma")}
          </Text>
        </FormField>
      )}

      {hasOfiDeadline && (
        <FormField direction="column" label="OFI Deadline" marginTop="large">
          <Text color={beforeOfiDeadline ? 'green' : 'red'} fontSize="small">
            {!beforeOfiDeadline && <><FontAwesomeIcon icon={faClock} />{' '}</>}

            {DateTime.fromFormat(ofiDeadline, 'dd/MM/yyyy HH:mm').toFormat("ccc d MMM 'at' h:mma")}
          </Text>
        </FormField>
      )}
    </>
  )
}

export default PublicationDetails
